const PARTIAL_HIGHLIGHT_LANGUAGES = new Set(['zh-cn', 'ja', 'zh-tw', 'ko']);

export default function getHighlightAccuracyForWordBreakerLanguage(
    wordBreakerLanguage?: string
): 'partially' | 'prefix' {
    return PARTIAL_HIGHLIGHT_LANGUAGES.has(wordBreakerLanguage?.toLowerCase() ?? '')
        ? 'partially'
        : 'prefix';
}
